import { componentFactory } from 'vue-tsx-support';

import type { RubricImageRecord } from '../../_items';
import { RubricImageRecordItem } from '../../_items';

type RecordInfo = {
  recordId: number;
  isCommercial: boolean;
};

type ViewRecordInfo = RecordInfo & { hasImage: boolean };

export default componentFactory.create({
  name: 'RubricImageRecordsList',
  props: {
    records: {
      type: Array as () => RubricImageRecord[],
      required: true as const
    }
  },
  methods: {
    emitCommentsClicked(recordInfo: RecordInfo, place: number): void {
      this.$emit('commentsClicked', {
        ...recordInfo,
        place
      });
    },
    emitHeaderClicked(recordInfo: RecordInfo, place: number): void {
      this.$emit('headerClicked', {
        ...recordInfo,
        place
      });
    },
    emitViewRecord(recordInfo: ViewRecordInfo): void {
      this.$emit('viewRecord', recordInfo);
    }
  },
  render() {
    return (
      <div>
        {this.records.map((record, index) => (
          <RubricImageRecordItem
            record={record}
            onCommentsClicked={(event: RecordInfo) =>
              this.emitCommentsClicked(event, index + 1)
            }
            onHeaderClicked={(event: RecordInfo) =>
              this.emitHeaderClicked(event, index + 1)
            }
            onViewRecord={this.emitViewRecord}
          />
        ))}
      </div>
    );
  }
});
